import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, CircularProgress, FormControl, Typography } from "@material-ui/core";

const styles = theme => ({
    btn: { textAlign: 'right', marginLeft: '50%', marginBottom: '0.3rem' },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh'
    },
    submit1: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

const CreateUserForm = (props) => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched } = formikProps;
                return (
                    <>
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['first_name'] || 'FirstName'}
                                placeholder={translations['first_name'] || 'FirstName'}
                                name="FirstName"
                                fullWidth={true}
                                value={values.FirstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.FirstName && touched.FirstName)}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['last_name'] || 'LastName'}
                                placeholder={translations['last_name'] || 'LastName'}
                                name="LastName"
                                fullWidth={true}
                                value={values.LastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.LastName && touched.LastName)}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['username'] || 'Username'}
                                placeholder={translations['username'] || 'Username'}
                                name="Username"
                                fullWidth={true}
                                value={values.Username}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Username && touched.Username)}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['password'] || 'Password'}
                                placeholder={translations['password'] || 'Password'}
                                name="Password"
                                fullWidth={true}
                                value={values.Password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Password && touched.Password)}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['email'] || 'Email'}
                                placeholder={translations['email'] || 'Email'}
                                name="Email"
                                fullWidth={true}
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Email && touched.Email)}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['user_position'] || 'Position'}
                                placeholder={translations['user_position'] || 'Position'}
                                name="Position"
                                fullWidth={true}
                                value={values.Position}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Position && touched.Position)}
                            />
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit1}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !(isValid && dirty)}
                                onClick={handleSubmit}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null
                        }
                    </>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(CreateUserForm);
